export default __webpack_public_path__ + "static/bandera-usa-f3820cb8a4c5328a4554cc887e416cef.svg";